var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticStyle: { width: "50%" } },
      [
        _c(
          "modal",
          {
            attrs: {
              name: "modalview",
              height: "auto",
              width: "100%",
              resizable: false,
              adaptive: false,
              scrollable: true
            }
          },
          [
            _c("div", { staticClass: "modal-header" }),
            _c(
              "div",
              {
                staticClass: "modal-body",
                staticStyle: { "text-align": "center" }
              },
              [
                _c(
                  "div",
                  { staticClass: "btn-pagenav" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn-closepreview",
                        on: { click: _vm.closePreview }
                      },
                      [_vm._v("入力画面に戻る")]
                    ),
                    _vm.checkPreviewFlag == true
                      ? _c(
                          "button",
                          {
                            staticClass: "btn-send",
                            on: { click: _vm.submit }
                          },
                          [_vm._v("送信")]
                        )
                      : _vm._e(),
                    _c("br"),
                    _c("Preview", {
                      ref: "Preview",
                      attrs: { val: _vm.mydata }
                    }),
                    _c("br"),
                    _c(
                      "button",
                      {
                        staticClass: "btn-closepreview",
                        on: { click: _vm.closePreview }
                      },
                      [_vm._v("入力画面に戻る")]
                    ),
                    _vm._v(" ; "),
                    _vm.checkPreviewFlag == true
                      ? _c(
                          "button",
                          {
                            staticClass: "btn-send",
                            on: { click: _vm.submit }
                          },
                          [_vm._v("送信")]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]
            )
          ]
        )
      ],
      1
    ),
    _c("div", { staticStyle: { width: "100%" } }, [
      _c("div", { staticClass: "gnav-wrap" }, [
        _c("div", { staticClass: "gnav" }, [
          _c("div", { class: _vm.navigationCss(1) }, [
            _c("span", { staticClass: "nav-number" }, [_vm._v("①")]),
            _c("span", { staticClass: "nav-contents" }, [
              _vm._v("氏名・生年月日")
            ])
          ]),
          _c("div", { class: _vm.navigationCss(2) }, [
            _c("span", { staticClass: "nav-number" }, [_vm._v("②")]),
            _c("span", { staticClass: "nav-contents" }, [
              _vm._v("住所・連絡先")
            ])
          ]),
          _c("div", { class: _vm.navigationCss(3) }, [
            _c("span", { staticClass: "nav-number" }, [_vm._v("③")]),
            _c("span", { staticClass: "nav-contents" }, [_vm._v("学歴・職歴")])
          ]),
          _c("div", { class: _vm.navigationCss(4) }, [
            _c("span", { staticClass: "nav-number" }, [_vm._v("④")]),
            _c("span", { staticClass: "nav-contents" }, [_vm._v("免許・資格")])
          ]),
          _c("div", { class: _vm.navigationCss(5) }, [
            _c("span", { staticClass: "nav-number" }, [_vm._v("⑤")]),
            _c("span", { staticClass: "nav-contents" }, [_vm._v("志望動機")])
          ]),
          _c("div", { class: _vm.navigationCss(6) }, [
            _c("span", { staticClass: "nav-number" }, [_vm._v("⑥")]),
            _c("span", { staticClass: "nav-contents" }, [_vm._v("本人希望欄")])
          ]),
          _c("div", { class: _vm.navigationCss(7) }, [
            _c("span", { staticClass: "nav-number" }, [_vm._v("⑦")]),
            _c("span", { staticClass: "nav-contents" }, [_vm._v("証明写真")])
          ])
        ])
      ]),
      _vm.page == 1
        ? _c("div", { staticClass: "contents-form" }, [
            _c("h1", [_vm._v("①氏名・生年月日")]),
            _vm._v(" プロフィールを入力してください。 "),
            _c(
              "div",
              { staticClass: "contents-explain" },
              _vm._l(_vm.errors, function(error) {
                return _c("div", { key: error }, [
                  _c(
                    "span",
                    { staticStyle: { color: "red", "font-weight": "bold" } },
                    [_vm._v(_vm._s(error))]
                  )
                ])
              }),
              0
            ),
            _c("label", [_vm._v("氏名：")]),
            _c(
              "div",
              { staticClass: "form-group", staticStyle: { display: "flex" } },
              [
                _c("span", { staticClass: "form-leftlabel" }, [_vm._v("姓")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.indata.fname,
                      expression: "indata.fname"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", required: "required" },
                  domProps: { value: _vm.indata.fname },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.indata, "fname", $event.target.value)
                    }
                  }
                }),
                _c("span", { staticClass: "form-leftlabel" }, [_vm._v("名")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.indata.lname,
                      expression: "indata.lname"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", required: "required" },
                  domProps: { value: _vm.indata.lname },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.indata, "lname", $event.target.value)
                    }
                  }
                })
              ]
            ),
            _c("label", [_vm._v("ふりがな：")]),
            _c(
              "div",
              { staticClass: "form-group", staticStyle: { display: "flex" } },
              [
                _c("span", { staticClass: "form-leftlabel" }, [_vm._v("せい")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.indata.fnamekana,
                      expression: "indata.fnamekana"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", required: "required" },
                  domProps: { value: _vm.indata.fnamekana },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.indata, "fnamekana", $event.target.value)
                    }
                  }
                }),
                _c("span", { staticClass: "form-leftlabel" }, [_vm._v("めい")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.indata.lnamekana,
                      expression: "indata.lnamekana"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", required: "required" },
                  domProps: { value: _vm.indata.lnamekana },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.indata, "lnamekana", $event.target.value)
                    }
                  }
                })
              ]
            ),
            _c("label", [_vm._v("性別：")]),
            _c(
              "div",
              { staticClass: "form-group", staticStyle: { display: "flex" } },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.indata.sex,
                      expression: "indata.sex"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "radio", value: "男" },
                  domProps: { checked: _vm._q(_vm.indata.sex, "男") },
                  on: {
                    change: function($event) {
                      return _vm.$set(_vm.indata, "sex", "男")
                    }
                  }
                }),
                _c("span", { staticClass: "form-addlabel" }, [_vm._v("男")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.indata.sex,
                      expression: "indata.sex"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "radio", value: "女" },
                  domProps: { checked: _vm._q(_vm.indata.sex, "女") },
                  on: {
                    change: function($event) {
                      return _vm.$set(_vm.indata, "sex", "女")
                    }
                  }
                }),
                _c("span", { staticClass: "form-addlabel" }, [_vm._v("女")])
              ]
            ),
            _c("label", [_vm._v("生年月日：")]),
            _c(
              "div",
              { staticClass: "form-group", staticStyle: { display: "flex" } },
              [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.indata.birthdayyear,
                        expression: "indata.birthdayyear"
                      }
                    ],
                    staticClass: "form-control",
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.indata,
                            "birthdayyear",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                        _vm.calcAge
                      ]
                    }
                  },
                  _vm._l(_vm.dateyears, function(w) {
                    return _c("option", { key: w.id }, [
                      _vm._v(_vm._s(w.label))
                    ])
                  }),
                  0
                ),
                _c("span", { staticClass: "form-addlabel" }, [_vm._v("年")]),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.indata.birthdaymonth,
                        expression: "indata.birthdaymonth"
                      }
                    ],
                    staticClass: "form-control",
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.indata,
                            "birthdaymonth",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                        _vm.calcAge
                      ]
                    }
                  },
                  _vm._l(_vm.datemonths, function(w) {
                    return _c("option", { key: w.id }, [
                      _vm._v(_vm._s(w.label))
                    ])
                  }),
                  0
                ),
                _c("span", { staticClass: "form-addlabel" }, [_vm._v("月")]),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.indata.birthdayday,
                        expression: "indata.birthdayday"
                      }
                    ],
                    staticClass: "form-control",
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.indata,
                            "birthdayday",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                        _vm.calcAge
                      ]
                    }
                  },
                  _vm._l(_vm.datedays, function(w) {
                    return _c("option", { key: w.id }, [
                      _vm._v(_vm._s(w.label))
                    ])
                  }),
                  0
                ),
                _c("span", { staticClass: "form-addlabel" }, [_vm._v("日")])
              ]
            ),
            _c(
              "div",
              { staticClass: "form-group", staticStyle: { display: "flex" } },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.indata.age,
                      expression: "indata.age"
                    }
                  ],
                  staticClass: "form-control",
                  staticStyle: { "text-align": "right", width: "70px" },
                  attrs: { type: "number", readonly: "" },
                  domProps: { value: _vm.indata.age },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.indata, "age", $event.target.value)
                    }
                  }
                }),
                _c("span", { staticClass: "form-addlabel" }, [_vm._v("歳")])
              ]
            ),
            _c("label", [_vm._v("扶養家族(配偶者を除く)：")]),
            _c(
              "div",
              { staticClass: "form-group", staticStyle: { display: "flex" } },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.indata.huyonin,
                      expression: "indata.huyonin"
                    }
                  ],
                  staticClass: "form-control",
                  staticStyle: { width: "100px" },
                  attrs: { type: "number", min: "0", max: "9" },
                  domProps: { value: _vm.indata.huyonin },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.indata, "huyonin", $event.target.value)
                    }
                  }
                }),
                _c("span", { staticClass: "form-addlabel" }, [_vm._v("人")])
              ]
            ),
            _c("label", [_vm._v("配偶者：")]),
            _c(
              "div",
              { staticClass: "form-group", staticStyle: { display: "flex" } },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.indata.haigusyaumu,
                      expression: "indata.haigusyaumu"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "radio", value: "有" },
                  domProps: { checked: _vm._q(_vm.indata.haigusyaumu, "有") },
                  on: {
                    change: function($event) {
                      return _vm.$set(_vm.indata, "haigusyaumu", "有")
                    }
                  }
                }),
                _c("span", { staticClass: "form-addlabel" }, [_vm._v("有")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.indata.haigusyaumu,
                      expression: "indata.haigusyaumu"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "radio", value: "無" },
                  domProps: { checked: _vm._q(_vm.indata.haigusyaumu, "無") },
                  on: {
                    change: function($event) {
                      return _vm.$set(_vm.indata, "haigusyaumu", "無")
                    }
                  }
                }),
                _c("span", { staticClass: "form-addlabel" }, [_vm._v("無")])
              ]
            ),
            _vm._m(0),
            _c(
              "div",
              { staticClass: "form-group", staticStyle: { display: "flex" } },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.indata.haigusyahuyogimu,
                      expression: "indata.haigusyahuyogimu"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "radio", value: "有" },
                  domProps: {
                    checked: _vm._q(_vm.indata.haigusyahuyogimu, "有")
                  },
                  on: {
                    change: function($event) {
                      return _vm.$set(_vm.indata, "haigusyahuyogimu", "有")
                    }
                  }
                }),
                _c("span", { staticClass: "form-addlabel" }, [_vm._v("有")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.indata.haigusyahuyogimu,
                      expression: "indata.haigusyahuyogimu"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "radio", value: "無" },
                  domProps: {
                    checked: _vm._q(_vm.indata.haigusyahuyogimu, "無")
                  },
                  on: {
                    change: function($event) {
                      return _vm.$set(_vm.indata, "haigusyahuyogimu", "無")
                    }
                  }
                }),
                _c("span", { staticClass: "form-addlabel" }, [_vm._v("無")])
              ]
            ),
            _vm._m(1),
            _c(
              "div",
              { staticClass: "form-group", staticStyle: { display: "flex" } },
              [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.indata.tukintimehour,
                        expression: "indata.tukintimehour"
                      }
                    ],
                    staticClass: "form-control",
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.indata,
                          "tukintimehour",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  _vm._l(_vm.timehours, function(w) {
                    return _c("option", { key: w.id }, [
                      _vm._v(_vm._s(w.label))
                    ])
                  }),
                  0
                ),
                _c("span", { staticClass: "form-addlabel" }, [_vm._v("時間")]),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.indata.tukintimeminute,
                        expression: "indata.tukintimeminute"
                      }
                    ],
                    staticClass: "form-control",
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.indata,
                          "tukintimeminute",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  _vm._l(_vm.timeminutes, function(w) {
                    return _c("option", { key: w.id }, [
                      _vm._v(_vm._s(w.label))
                    ])
                  }),
                  0
                ),
                _c("span", { staticClass: "form-addlabel" }, [_vm._v("分")])
              ]
            ),
            _c("div", { staticClass: "btn-pagenav" }, [
              _c(
                "button",
                { staticClass: "btn-preview", on: { click: _vm.openPreview } },
                [_vm._v("プレビュー")]
              )
            ])
          ])
        : _vm._e(),
      _vm.page == 2
        ? _c("div", { staticClass: "contents-form" }, [
            _c("h1", [_vm._v("②住所・連絡先")]),
            _vm._m(2),
            _c(
              "div",
              { staticClass: "contents-explain" },
              _vm._l(_vm.errors, function(error) {
                return _c("div", { key: error }, [
                  _c(
                    "span",
                    { staticStyle: { color: "red", "font-weight": "bold" } },
                    [_vm._v(_vm._s(error))]
                  )
                ])
              }),
              0
            ),
            _c("h2", { staticClass: "subtitle" }, [_vm._v("■現住所")]),
            _c("label", [_vm._v("郵便番号：")]),
            _c(
              "div",
              { staticClass: "form-group", staticStyle: { display: "flex" } },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.indata.gen.zipcode,
                      expression: "indata.gen.zipcode"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.indata.gen.zipcode },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.indata.gen, "zipcode", $event.target.value)
                    }
                  }
                })
              ]
            ),
            _c("label", [_vm._v("住所：")]),
            _c("br"),
            _c(
              "div",
              { staticClass: "form-group", staticStyle: { display: "flex" } },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.indata.gen.prefname,
                      expression: "indata.gen.prefname"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "hidden" },
                  domProps: { value: _vm.indata.gen.prefname },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.indata.gen, "prefname", $event.target.value)
                    }
                  }
                }),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.indata.gen.address,
                      expression: "indata.gen.address"
                    }
                  ],
                  staticClass: "form-control",
                  staticStyle: { width: "100%" },
                  attrs: { type: "text" },
                  domProps: { value: _vm.indata.gen.address },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.indata.gen, "address", $event.target.value)
                    }
                  }
                })
              ]
            ),
            _c("span", { staticClass: "sublabel" }, [_vm._v(" 建物名(任意)")]),
            _c(
              "div",
              { staticClass: "form-group", staticStyle: { display: "flex" } },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.indata.gen.address2,
                      expression: "indata.gen.address2"
                    }
                  ],
                  staticClass: "form-control",
                  staticStyle: { width: "100%" },
                  attrs: { type: "text" },
                  domProps: { value: _vm.indata.gen.address2 },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.indata.gen, "address2", $event.target.value)
                    }
                  }
                })
              ]
            ),
            _c("label", [_vm._v("ふりがな：")]),
            _c(
              "div",
              { staticClass: "form-group", staticStyle: { display: "flex" } },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.indata.gen.prefnamekana,
                      expression: "indata.gen.prefnamekana"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "hidden" },
                  domProps: { value: _vm.indata.gen.prefnamekana },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.indata.gen,
                        "prefnamekana",
                        $event.target.value
                      )
                    }
                  }
                }),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.indata.gen.addresskana,
                      expression: "indata.gen.addresskana"
                    }
                  ],
                  staticClass: "form-control",
                  staticStyle: { width: "100%" },
                  attrs: { type: "text" },
                  domProps: { value: _vm.indata.gen.addresskana },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.indata.gen,
                        "addresskana",
                        $event.target.value
                      )
                    }
                  }
                })
              ]
            ),
            _c("span", { staticClass: "sublabel" }, [_vm._v(" 建物名(任意)")]),
            _c(
              "div",
              { staticClass: "form-group", staticStyle: { display: "flex" } },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.indata.gen.addresskana2,
                      expression: "indata.gen.addresskana2"
                    }
                  ],
                  staticClass: "form-control",
                  staticStyle: { width: "100%" },
                  attrs: { type: "text" },
                  domProps: { value: _vm.indata.gen.addresskana2 },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.indata.gen,
                        "addresskana2",
                        $event.target.value
                      )
                    }
                  }
                })
              ]
            ),
            _c("label", [_vm._v("電話番号：")]),
            _c(
              "div",
              { staticClass: "form-group", staticStyle: { display: "flex" } },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.indata.gen.tel,
                      expression: "indata.gen.tel"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "tel" },
                  domProps: { value: _vm.indata.gen.tel },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.indata.gen, "tel", $event.target.value)
                    }
                  }
                })
              ]
            ),
            _c("label", [_vm._v("メールアドレス：")]),
            _c(
              "div",
              { staticClass: "form-group", staticStyle: { display: "flex" } },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.indata.gen.email,
                      expression: "indata.gen.email"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "email" },
                  domProps: { value: _vm.indata.gen.email },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.indata.gen, "email", $event.target.value)
                    }
                  }
                })
              ]
            ),
            _vm._m(3),
            _c(
              "label",
              { staticClass: "acd-label", attrs: { for: "acd-check1" } },
              [_vm._v("■その他の連絡先")]
            ),
            _c("span", { staticClass: "subdoc" }, [
              _vm._v("※現住所と連絡先が異なる場合のみご記入ください")
            ]),
            _c("input", {
              staticClass: "acd-check",
              attrs: { id: "acd-check1", type: "checkbox" }
            }),
            _c("div", { staticClass: "acd-content" }, [
              _c("label", [_vm._v("郵便番号：")]),
              _c(
                "div",
                { staticClass: "form-group", staticStyle: { display: "flex" } },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.indata.renraku.zipcode,
                        expression: "indata.renraku.zipcode"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: { value: _vm.indata.renraku.zipcode },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.indata.renraku,
                          "zipcode",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]
              ),
              _c("label", [_vm._v("住所：")]),
              _c(
                "div",
                { staticClass: "form-group", staticStyle: { display: "flex" } },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.indata.renraku.prefname,
                        expression: "indata.renraku.prefname"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "hidden" },
                    domProps: { value: _vm.indata.renraku.prefname },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.indata.renraku,
                          "prefname",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.indata.renraku.address,
                        expression: "indata.renraku.address"
                      }
                    ],
                    staticClass: "form-control",
                    staticStyle: { width: "100%" },
                    attrs: { type: "text" },
                    domProps: { value: _vm.indata.renraku.address },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.indata.renraku,
                          "address",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]
              ),
              _c("span", { staticClass: "sublabel" }, [
                _vm._v(" 建物名(任意)")
              ]),
              _c(
                "div",
                { staticClass: "form-group", staticStyle: { display: "flex" } },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.indata.renraku.address2,
                        expression: "indata.renraku.address2"
                      }
                    ],
                    staticClass: "form-control",
                    staticStyle: { width: "100%" },
                    attrs: { type: "text" },
                    domProps: { value: _vm.indata.renraku.address2 },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.indata.renraku,
                          "address2",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]
              ),
              _c("label", [_vm._v("ふりがな：")]),
              _c(
                "div",
                { staticClass: "form-group", staticStyle: { display: "flex" } },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.indata.renraku.prefnamekana,
                        expression: "indata.renraku.prefnamekana"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "hidden" },
                    domProps: { value: _vm.indata.renraku.prefnamekana },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.indata.renraku,
                          "prefnamekana",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.indata.renraku.addresskana,
                        expression: "indata.renraku.addresskana"
                      }
                    ],
                    staticClass: "form-control",
                    staticStyle: { width: "100%" },
                    attrs: { type: "text" },
                    domProps: { value: _vm.indata.renraku.addresskana },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.indata.renraku,
                          "addresskana",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]
              ),
              _c("span", { staticClass: "sublabel" }, [
                _vm._v(" 建物名(任意)")
              ]),
              _c(
                "div",
                { staticClass: "form-group", staticStyle: { display: "flex" } },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.indata.renraku.addresskana2,
                        expression: "indata.renraku.addresskana2"
                      }
                    ],
                    staticClass: "form-control",
                    staticStyle: { width: "100%" },
                    attrs: { type: "text" },
                    domProps: { value: _vm.indata.renraku.addresskana2 },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.indata.renraku,
                          "addresskana2",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]
              ),
              _c("label", [_vm._v("電話番号：")]),
              _c(
                "div",
                { staticClass: "form-group", staticStyle: { display: "flex" } },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.indata.renraku.tel,
                        expression: "indata.renraku.tel"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "tel" },
                    domProps: { value: _vm.indata.renraku.tel },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.indata.renraku, "tel", $event.target.value)
                      }
                    }
                  })
                ]
              ),
              _c("label", [_vm._v("メールアドレス：")]),
              _c(
                "div",
                { staticClass: "form-group", staticStyle: { display: "flex" } },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.indata.renraku.email,
                        expression: "indata.renraku.email"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "email" },
                    domProps: { value: _vm.indata.renraku.email },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.indata.renraku,
                          "email",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]
              )
            ]),
            _c("div", { staticClass: "btn-pagenav" }, [
              _c(
                "button",
                { staticClass: "btn-preview", on: { click: _vm.openPreview } },
                [_vm._v("プレビュー")]
              )
            ])
          ])
        : _vm._e(),
      _vm.page == 3
        ? _c("div", { staticClass: "contents-form" }, [
            _c("h1", [_vm._v("③学歴・職歴")]),
            _vm._v(
              " ※義務教育以降の高校、専門学校などから記入してください。学校名は、略さず正式名称で記入し、「高校」ではなく「高等学校」と書いてください。 "
            ),
            _c(
              "div",
              {
                staticClass: "contents-explain",
                staticStyle: { "padding-top": "0", "padding-bottom": "0" }
              },
              _vm._l(_vm.errors, function(error) {
                return _c("div", { key: error }, [
                  _c(
                    "span",
                    { staticStyle: { color: "red", "font-weight": "bold" } },
                    [_vm._v(_vm._s(error))]
                  )
                ])
              }),
              0
            ),
            _c(
              "table",
              {
                staticStyle: {
                  width: "100%",
                  "border-spacing": "0px 5px",
                  "font-size": "0.8em"
                }
              },
              [
                _vm._m(4),
                _c(
                  "tbody",
                  _vm._l(_vm.indata.gakusyokus, function(gakusyoku) {
                    return _c("tr", { key: gakusyoku.id }, [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "80px",
                            "vertical-align": "top"
                          }
                        },
                        [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: gakusyoku.year,
                                  expression: "gakusyoku.year"
                                }
                              ],
                              staticClass: "form-control",
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    gakusyoku,
                                    "year",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                }
                              }
                            },
                            _vm._l(_vm.dateyears, function(w) {
                              return _c("option", { key: w.id }, [
                                _vm._v(_vm._s(w.label))
                              ])
                            }),
                            0
                          )
                        ]
                      ),
                      _vm._m(5, true),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "60px",
                            "vertical-align": "top"
                          }
                        },
                        [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: gakusyoku.month,
                                  expression: "gakusyoku.month"
                                }
                              ],
                              staticClass: "form-control",
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    gakusyoku,
                                    "month",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                }
                              }
                            },
                            _vm._l(_vm.datemonths, function(w) {
                              return _c("option", { key: w.id }, [
                                _vm._v(_vm._s(w.label))
                              ])
                            }),
                            0
                          )
                        ]
                      ),
                      _vm._m(6, true),
                      _c("td", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: gakusyoku.content,
                              expression: "gakusyoku.content"
                            }
                          ],
                          staticClass: "form-control",
                          staticStyle: { width: "100%" },
                          attrs: { type: "text" },
                          domProps: { value: gakusyoku.content },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                gakusyoku,
                                "content",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ])
                  }),
                  0
                )
              ]
            ),
            _c("div", { staticClass: "btn-pagenav" }, [
              _c(
                "button",
                { staticClass: "btn-preview", on: { click: _vm.openPreview } },
                [_vm._v("プレビュー")]
              )
            ])
          ])
        : _vm._e(),
      _vm.page == 4
        ? _c("div", { staticClass: "contents-form" }, [
            _c("h1", [_vm._v("④免許・資格")]),
            _vm._v(
              " ※最初に免許を書き、次に資格を記入してください。取得時から、資格の名称が変わっている場合は、取得時の資格名を記入してください。 "
            ),
            _c(
              "div",
              {
                staticClass: "contents-explain",
                staticStyle: { "padding-top": "0", "padding-bottom": "0" }
              },
              _vm._l(_vm.errors, function(error) {
                return _c("div", { key: error }, [
                  _c(
                    "span",
                    { staticStyle: { color: "red", "font-weight": "bold" } },
                    [_vm._v(_vm._s(error))]
                  )
                ])
              }),
              0
            ),
            _c(
              "table",
              {
                staticStyle: {
                  width: "100%",
                  "border-spacing": "0px 5px",
                  "font-size": "0.8em"
                }
              },
              [
                _vm._m(7),
                _c(
                  "tbody",
                  _vm._l(_vm.indata.menkyosikakus, function(menkyosikaku) {
                    return _c("tr", { key: menkyosikaku.id }, [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "80px",
                            "vertical-align": "top"
                          }
                        },
                        [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: menkyosikaku.year,
                                  expression: "menkyosikaku.year"
                                }
                              ],
                              staticClass: "form-control",
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    menkyosikaku,
                                    "year",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                }
                              }
                            },
                            _vm._l(_vm.dateyears, function(w) {
                              return _c("option", { key: w.id }, [
                                _vm._v(_vm._s(w.label))
                              ])
                            }),
                            0
                          )
                        ]
                      ),
                      _vm._m(8, true),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "60px",
                            "vertical-align": "top"
                          }
                        },
                        [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: menkyosikaku.month,
                                  expression: "menkyosikaku.month"
                                }
                              ],
                              staticClass: "form-control",
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    menkyosikaku,
                                    "month",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                }
                              }
                            },
                            _vm._l(_vm.datemonths, function(w) {
                              return _c("option", { key: w.id }, [
                                _vm._v(_vm._s(w.label))
                              ])
                            }),
                            0
                          )
                        ]
                      ),
                      _vm._m(9, true),
                      _c("td", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: menkyosikaku.content,
                              expression: "menkyosikaku.content"
                            }
                          ],
                          staticClass: "form-control",
                          staticStyle: { width: "100%" },
                          attrs: { type: "text" },
                          domProps: { value: menkyosikaku.content },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                menkyosikaku,
                                "content",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ])
                  }),
                  0
                )
              ]
            ),
            _c("div", { staticClass: "btn-pagenav" }, [
              _c(
                "button",
                { staticClass: "btn-preview", on: { click: _vm.openPreview } },
                [_vm._v("プレビュー")]
              )
            ])
          ])
        : _vm._e(),
      _vm.page == 5
        ? _c("div", { staticClass: "contents-form" }, [
            _c("h1", [_vm._v("⑤志望動機")]),
            _vm._v(
              " 特技や好きな学科など、ご自身のアピールポイントを記入してください。 "
            ),
            _c(
              "div",
              { staticClass: "contents-explain" },
              _vm._l(_vm.errors, function(error) {
                return _c("div", { key: error }, [
                  _c(
                    "span",
                    { staticStyle: { color: "red", "font-weight": "bold" } },
                    [_vm._v(_vm._s(error))]
                  )
                ])
              }),
              0
            ),
            _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v("志望動機：")]),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.indata.sibodoki,
                    expression: "indata.sibodoki"
                  }
                ],
                staticClass: "form-control",
                staticStyle: {
                  width: "100%",
                  height: "200px",
                  "font-size": "14pt"
                },
                attrs: { type: "text" },
                domProps: { value: _vm.indata.sibodoki },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.indata, "sibodoki", $event.target.value)
                  }
                }
              })
            ]),
            _c("div", { staticClass: "btn-pagenav" }, [
              _c(
                "button",
                { staticClass: "btn-preview", on: { click: _vm.openPreview } },
                [_vm._v("プレビュー")]
              )
            ])
          ])
        : _vm._e(),
      _vm.page == 6
        ? _c("div", { staticClass: "contents-form" }, [
            _c("h1", [_vm._v("⑥本人希望欄")]),
            _vm._v(
              " 給与・職種・勤務時間・勤務地などのご希望を記入してください。 "
            ),
            _c(
              "div",
              { staticClass: "contents-explain" },
              _vm._l(_vm.errors, function(error) {
                return _c("div", { key: error }, [
                  _c(
                    "span",
                    { staticStyle: { color: "red", "font-weight": "bold" } },
                    [_vm._v(_vm._s(error))]
                  )
                ])
              }),
              0
            ),
            _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v("本人希望欄：")]),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.indata.honninkiboran,
                    expression: "indata.honninkiboran"
                  }
                ],
                staticClass: "form-control",
                staticStyle: {
                  width: "100%",
                  height: "200px",
                  "font-size": "14pt"
                },
                domProps: { value: _vm.indata.honninkiboran },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.indata, "honninkiboran", $event.target.value)
                  }
                }
              })
            ]),
            _c("div", { staticClass: "btn-pagenav" }, [
              _c(
                "button",
                { staticClass: "btn-preview", on: { click: _vm.openPreview } },
                [_vm._v("プレビュー")]
              )
            ])
          ])
        : _vm._e(),
      _vm.page == 7
        ? _c("div", { staticClass: "contents-form" }, [
            _c("h1", [_vm._v("⑦証明写真")]),
            _vm._v(" 使用する写真について "),
            _vm._m(10),
            _c(
              "div",
              { staticClass: "contents-explain" },
              _vm._l(_vm.errors, function(error) {
                return _c("div", { key: error }, [
                  _c(
                    "span",
                    { staticStyle: { color: "red", "font-weight": "bold" } },
                    [_vm._v(_vm._s(error))]
                  )
                ])
              }),
              0
            ),
            _c(
              "div",
              {
                staticClass: "form-group",
                staticStyle: { "text-align": "center" }
              },
              [
                _c("img", {
                  staticStyle: {},
                  attrs: { src: _vm.indata.myphoto.bindata, width: "120px" }
                })
              ]
            ),
            _c(
              "div",
              {
                class: _vm.classesDragArea,
                staticStyle: { "text-align": "center" },
                on: {
                  dragover: function($event) {
                    $event.preventDefault()
                    return _vm.onArea($event)
                  },
                  drop: function($event) {
                    $event.preventDefault()
                    return _vm.dropFile($event)
                  },
                  dragleave: function($event) {
                    $event.preventDefault()
                    return _vm.offArea($event)
                  },
                  dragend: function($event) {
                    $event.preventDefault()
                    return _vm.offArea($event)
                  }
                }
              },
              [
                _c("label", { staticClass: "drag-label drop-area" }, [
                  _vm._v("ファイルを選択 "),
                  _c("input", {
                    ref: "file",
                    attrs: { type: "file", id: "file", mulitple: "multiple" },
                    on: { change: _vm.setImage }
                  })
                ])
              ]
            ),
            _c("div", { staticClass: "btn-pagenav" }, [
              _c(
                "button",
                { staticClass: "btn-preview", on: { click: _vm.openPreview } },
                [_vm._v("プレビュー")]
              )
            ])
          ])
        : _vm._e()
    ]),
    _c("div", { staticClass: "btn-pagenav" }, [
      _c("div", {}, [
        _vm.page < 7
          ? _c(
              "button",
              {
                staticClass: "btn-next",
                attrs: { type: "button" },
                on: { click: _vm.next }
              },
              [_vm._v("次へ")]
            )
          : _vm._e(),
        _vm.page == 7
          ? _c(
              "button",
              {
                staticClass: "btn-send",
                attrs: { type: "button" },
                on: { click: _vm.checkPreview }
              },
              [_vm._v("送信")]
            )
          : _vm._e(),
        _vm.page > 1
          ? _c(
              "button",
              {
                staticClass: "btn-previous",
                attrs: { type: "button" },
                on: { click: _vm.prev }
              },
              [_vm._v("戻る")]
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _vm._v("配偶者の扶養義務："),
      _c("br"),
      _c("span", { staticClass: "subdoc" }, [
        _vm._v("※扶養家族とは、自分の収入で養っている家族のことを言います。")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _vm._v("通勤時間："),
      _c("br"),
      _c("span", { staticClass: "subdoc" }, [
        _vm._v(
          "※通勤時間とは、自宅から会社までにかかる片道の所要時間のことです。徒歩、自転車、車、公共交通機関など、通勤にかかるすべての時間を合計した時間です。自宅を出たところから、勤務地に入るまでの時間を選択してください。"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "titledoc" }, [
      _vm._v("住所と連絡先を入力してください。"),
      _c("br"),
      _vm._v(
        " 建物名や部屋番号は略さず入力しましょう。ふりがなの番地などの数字は入力不要です。"
      ),
      _c("br"),
      _vm._v(" 連絡先は連絡が付きやすい番号。メールアドレスをご記入ください。"),
      _c("br")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group" }, [_c("br")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_c("label", [_vm._v("(西暦)：")])]),
        _c("th"),
        _c("th"),
        _c("th"),
        _c("th", [_c("label", [_vm._v("学歴・職歴：")])])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticStyle: { width: "20px" } }, [
      _c("span", [_vm._v(" 年")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticStyle: { width: "20px" } }, [
      _c("span", [_vm._v(" 月")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_c("label", [_vm._v("年(西暦)：")])]),
        _c("th"),
        _c("th"),
        _c("th"),
        _c("th", [_c("label", [_vm._v("免許・資格：")])])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticStyle: { width: "20px" } }, [
      _c("span", [_vm._v("年")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticStyle: { width: "20px" } }, [
      _c("span", [_vm._v("月")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", [
      _c("li", [_vm._v("● 撮影から3ヶ月以内のものを使用してください。")]),
      _c("li", [
        _vm._v("● 本人とわかる、単身胸から上の画像をしようしてください。")
      ]),
      _c("li", [
        _vm._v(
          "● 縦36mm~40mm / 横24mm~30mmのサイズで撮影またはトリミングします。"
        )
      ]),
      _c("li", [_vm._v("● 写真の背景はブルー（水色）または白を選びましょう。")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }